/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! GhostStat AI Crawlers viewer. */
(function () {
  "use strict";
  /* Answers "is the deployed file the new one?" without a deploy archaeology session. If the
     console does not say 1.0.1, a stale edge copy is being served — purge the CDN. */
  try { (window.GS_BUILD = window.GS_BUILD || {})["ai-crawlers"] = "1.0.2"; } catch (e) {}
  
  
  function bsCls(v){return v>=70?"s-hi":(v>=40?"s-mid":"s-lo");}
  /* Same explainer as BotTracker: a bare 0-100 tells you nothing about direction or evidence. */
  function bsTip(b){
    var t = ["BotScore " + b.botscore + "/100 \u2014 how strongly this traffic behaves like automation.",
             TR('aicraw.f3.higher_more_bot_like_scored_from_r'),
             "user-agent alone, which anyone can set."];
    if (b.botscore_cat) t.splice(1, 0, "Behaviour: " + b.botscore_cat);
    if (b.botscore_conf != null) t.splice(b.botscore_cat ? 2 : 1, 0,
      "Confidence " + Math.round((+b.botscore_conf || 0) * 100) + "% \u2014 how much evidence the score rests on.");
    return t.join("\n");
  }
  function bsBadge(b){ if(b.botscore==null) return "";
    return ' <span class="bscore '+bsCls(b.botscore)+'" title="'+esc(bsTip(b))+'"><i class="bi bi-robot"></i>'+b.botscore+"</span>"; }

  /* Who operates this AI crawler. owner/url are null for anything not in BotSignatures' table —
     the name then stands alone rather than carrying an invented operator. */
  function botName(b){
    var t = [];
    if (b.owner) t.push("Operated by " + b.owner);
    t.push(TR('aicraw.g.ai_llm_crawler_u2014_collects_pages_'));
    t.push(b.verified
      ? TR('aicraw.f3.verified_u2014_the_request_came_fr')
      : "Not verified \u2014 the user-agent claims this crawler, but the IP is not in the operator's published ranges (or none are published).");
    if (b.last_seen) t.push("Last seen " + b.last_seen);
    if (b.url) t.push(TR('aicraw.p.click_the_name_for_the_operator_s_ow'));
    var label = esc(b.name);
    if (b.url) label = '<a class="bot-doc" href="'+esc(b.url)+'" target="_blank" rel="noopener noreferrer nofollow">'+label+'</a>';
    return '<span class="bot-nm" title="'+esc(t.join("\n"))+'">'+label+(b.owner?'<span class="bot-own">'+esc(b.owner)+"</span>":"")+"</span>";
  }
function ic(n){return (window.GSIcons&&GSIcons.svg)?(GSIcons.svg(n,16)+" "):"";}
if (window.__aiWired) return; window.__aiWired = 1;
  var root;
  function q(s) { return root ? root.querySelector('[data-i="' + s + '"]') : null; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function siteParam() { return "site=" + encodeURIComponent((window.GS && GS.site) || ""); }
  function ready(fn) { var done = false; function go() { if (done) return; done = true; fn(); } document.addEventListener("gs:ready", go, { once: true }); var n = 0, t = setInterval(function () { if (window.GS && GS.api && GS.site) { clearInterval(t); go(); } else if (++n > 200) clearInterval(t); }, 30); if (window.GS && GS.api && GS.site) go(); }
  function ago(s) { if (!s) return "\u2014"; var d = new Date(s.replace(" ", "T") + "Z"); var sec = (Date.now() - d.getTime()) / 1000; if (isNaN(sec)) return esc(s); if (sec < 90) return "just now"; if (sec < 3600) return Math.round(sec / 60) + "m ago"; if (sec < 86400) return Math.round(sec / 3600) + "h ago"; return Math.round(sec / 86400) + "d ago"; }

  function vbadge(b) {
    if (b.sessions && b.verified >= b.sessions) return '<span class="vbadge ok"><i class="bi bi-shield-check"></i>'+TR('aicraw.g.verified')+'</span>';
    if (b.verified > 0) return '<span class="vbadge part"><i class="bi bi-shield"></i>' + b.verified + "/" + b.sessions + "</span>";
    return '<span class="vbadge no"><i class="bi bi-shield-slash"></i>'+TR('aicraw.g.unverified')+'</span>';
  }
  function renderPurps(purps) {
    var host = q("purps");
    if (!purps.length) { host.innerHTML = '<div class="empty">'+TR('aicraw.f2.no_ai_crawlers_in_this_range')+'</div>'; return; }
    var max = purps[0].share || 1;
    host.innerHTML = purps.map(function (p) {
      return '<div class="prow"><div class="top"><span class="dot" style="background:' + esc(p.color) + '"></span>' + esc(p.label) +
        '<span class="pct num">' + p.share + '%</span></div>' +
        '<div class="track"><i style="width:' + Math.max(3, Math.round(p.share / max * 100)) + '%;background:' + esc(p.color) + '"></i></div>' +
        '<div class="n">' + p.sessions.toLocaleString() + ' sessions</div></div>';
    }).join("");
  }
  function renderDaily(days) {
    var host = q("daily");
    if (!days || !days.length) { host.innerHTML = '<div class="empty">'+TR('aicraw.f2.no_crawl_activity')+'</div>'; return; }
    var max = days.reduce(function (m, d) { return Math.max(m, d.sessions || 0); }, 1);
    host.innerHTML = days.map(function (d) {
      return '<div class="dcol" title="' + d.date + ": " + (d.sessions || 0) + ' AI sessions" style="height:' + Math.max(2, Math.round((d.sessions || 0) / max * 100)) + '%"></div>';
    }).join("");
  }
  function renderTable(bots) {
    var tb = q("tbody");
    function aiRow(b) {
      var thr = b.bad ? ' <span class="thr"><i class="bi bi-exclamation-triangle-fill"></i>' + esc(b.threat === "spoofed" ? "Spoofed" : "Bad") + "</span>" : "";
      return "<tr" + (b.bad ? ' class="bad"' : "") + '><td class="bn">' + ic(b.name) + botName(b) + thr + bsBadge(b) + "</td>" +
        '<td><span class="badge" style="background:' + esc(b.color) + '1a;color:' + esc(b.color) + '"><span class="d" style="background:' + esc(b.color) + '"></span>' + esc(b.purpose_label) + "</span></td>" +
        '<td class="r num">' + b.sessions.toLocaleString() + '</td>' +
        '<td class="r num">' + b.pages.toLocaleString() + '</td>' +
        '<td class="r num">' + b.countries + '</td>' +
        '<td>' + vbadge(b) + '</td>' +
        '<td class="r">' + ago(b.last_seen) + '</td></tr>';
    }
    bots = bots || [];
    if (window.GSMore) GSMore.mount({ container: tb, table: true, colspan: 7, items: bots, pageSize: 20, emptyText: TR('aicraw.f2.no_ai_crawlers_detected_in_this_ra'), render: aiRow });
    else tb.innerHTML = bots.length ? bots.map(aiRow).join("") : '<tr><td colspan="7" class="empty">'+TR('aicraw.f2.no_ai_crawlers_detected_in_this_ra')+'</td></tr>';
  }
  function render(d) {
    var t = d.totals || {};
    q("k-sessions").textContent = (t.sessions || 0).toLocaleString();
    q("k-pages").textContent = (t.pages || 0).toLocaleString();
    q("k-unique").textContent = (t.unique_bots || 0).toLocaleString();
    q("k-verified").textContent = (t.verified_pct || 0) + "%";
    renderPurps(d.purposes || []); renderDaily(d.days || []); renderTable(d.bots || []);
  }
  function load() {
    GS.api("/plugin/ai-crawlers/overview?" + siteParam() + "&from=" + RANGE.from + "&to=" + RANGE.to).then(function (r) {
      if (r.ok && r.data) render(r.data);
    });
  }

  function _ymd(d) { return d.getUTCFullYear() + "-" + ("0" + (d.getUTCMonth() + 1)).slice(-2) + "-" + ("0" + d.getUTCDate()).slice(-2); }
  function _today() { var t = new Date(); return new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate())); }
  function T(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
  function preset(days) { var to = _today(), from = new Date(to.getTime() - (days - 1) * 86400000); var lbl = { 7: T("an.last7"), 30: T("an.last30"), 90: T("an.last90"), 365: T("an.last12mo") }[days] || T("an.lastndays",{n:days}); return { from: _ymd(from), to: _ymd(to), label: lbl, preset: String(days) }; }
  var RANGE = (function () { try { var s = JSON.parse(localStorage.getItem("gs_ai_range") || "null"); /* A stored preset is a RULE ("last 30 days"), not a fixed window. Restoring its
     absolute from/to means "last 30 days" quietly becomes "the 30 days ending whenever
     you last touched the picker" — today falls outside the range, the page looks stale,
     and Refresh re-queries the same dead window forever. Re-anchor presets to today;
     a CUSTOM range is genuinely absolute and is kept as stored. */
  if (s && s.preset) return preset(+s.preset);
  if (s && s.from && s.to) return s; } catch (e) {} return preset(30); })();
  function saveRange() { try { localStorage.setItem("gs_ai_range", JSON.stringify(RANGE)); } catch (e) {} }
  function initRange() {
    var btn = q("rangeBtn"), menu = q("rangeMenu"), lab = q("range-label"); if (!btn || !menu) return;
    if (lab && RANGE.label) lab.textContent = RANGE.label;
    function sync() { menu.querySelectorAll(".rm[data-preset]").forEach(function (x) { x.classList.toggle("on", x.getAttribute("data-preset") === RANGE.preset); }); }
    sync();
    btn.addEventListener("click", function (e) { if (menu.contains(e.target) && e.target !== btn) return; e.stopPropagation(); var open = menu.style.display !== "none"; menu.style.display = open ? "none" : "block"; if (!open) { var cf = menu.querySelector('[data-rp="from"]'), ct = menu.querySelector('[data-rp="to"]'); if (cf) cf.value = RANGE.from; if (ct) ct.value = RANGE.to; sync(); } });
    document.addEventListener("click", function () { menu.style.display = "none"; });
    menu.addEventListener("click", function (e) { e.stopPropagation(); });
    function apply(r) { RANGE = r; if (lab) lab.textContent = RANGE.label; saveRange(); menu.style.display = "none"; load(); }
    menu.querySelectorAll(".rm[data-preset]").forEach(function (b) { b.addEventListener("click", function () { apply(preset(+b.getAttribute("data-preset"))); }); });
    var ap = menu.querySelector('[data-rp="apply"]'); if (ap) ap.addEventListener("click", function () { var f = menu.querySelector('[data-rp="from"]').value, t = menu.querySelector('[data-rp="to"]').value; if (!f || !t) return; if (f > t) { var x = f; f = t; t = x; } apply({ from: f, to: t, label: f + " \u2192 " + t, preset: null }); });
  }
  function init() { root = document.querySelector('[data-i="root"]'); if (!root) return; var rf = q("refresh"); if (rf) rf.addEventListener("click", load); initRange(); load(); }
  ready(init);
})();
